<div class="full-modal-config-header-tabs">
    <ul
        class="full-modal-config-header-tabs__tabs-list"
        role="tablist"
    >
        <li
            *ngFor="let tab of tabs; trackBy: trackByTabId"
            class="full-modal-config-header-tabs__tab"
            [ngClass]="getTabClassName(tab)"
            (click)="handleSelect(tab)"
            (keydown.enter)="handleSelect(tab)"
            (keydown.space)="handleSelect(tab)"
            role="tab"
            tabindex="0"
        >
            {{ tab.title }}
        </li>
    </ul>
</div>
